import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../share-modul/services/authentication/authentication.service';

@Injectable()
export class ApiHttpInterceptor implements HttpInterceptor {

  constructor(private authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const jwt = this.authenticationService.token != undefined ? this.authenticationService.token : this.authenticationService.waiterToken;
      return next.handle( jwt ? request.clone({ setHeaders: { Authorization: `Bearer ${jwt}`  }}) : request);
  }
}
